import { useEffect } from 'react';

interface SEOHeadProps {
  title?: string;
  description?: string;
  robots?: string;
  canonical?: string;
}

export function SEOHead({ title, description, robots, canonical }: SEOHeadProps) {
  useEffect(() => {
    // タイトル設定
    if (title) {
      document.title = title;
    }
    
    // description設定
    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.setAttribute('name', 'description');
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', description);
    }
    
    // robots設定
    if (robots) {
      let metaRobots = document.querySelector('meta[name="robots"]');
      if (!metaRobots) {
        metaRobots = document.createElement('meta');
        metaRobots.setAttribute('name', 'robots');
        document.head.appendChild(metaRobots);
      }
      metaRobots.setAttribute('content', robots);
    }
    
    // canonical設定
    if (canonical) {
      let linkCanonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
      if (!linkCanonical) {
        linkCanonical = document.createElement('link');
        linkCanonical.setAttribute('rel', 'canonical');
        document.head.appendChild(linkCanonical);
      }
      linkCanonical.href = canonical;
    }
  }, [title, description, robots, canonical]);
  
  return null;
}

export default SEOHead;